import API from '../api'

export type MovePreCheck = {
  consultCount: number,
  invoiceCount: number
}

export const movePreCheckEndpoint = `/web/jobs/move/pre-check/`
export const moveEndpoint = `/web/jobs/move`

export const movePreCheck = async (jobId: number) => {
    return (await API.get<MovePreCheck>(`${movePreCheckEndpoint}${jobId}`)).data
}

export type MoveRequest = {
    jobId: number
    newCustomerId: number
    newPropertyId: number
}

type MoveResponse = {
  errorMessage?: string
}

export const move = async (request: MoveRequest) => {
  const result = await API.post<MoveResponse>(moveEndpoint, request, {validateStatus: () => true})

  if (result.status !== 200) {
    throw new Error(result.data.errorMessage)
  }
}
